<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-users text-primary mr-2"></i>
                    Gestión de Roles
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Listado
                    <export-actions :rows="getRolesFilteredData()"></export-actions>
                </b-row>
                <v-client-table
                    ref="RolesTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="roles"
                    :options="options"
                    :theme="theme" @filter="onFilter">

                    <template slot="uuid" slot-scope="props">
                        <router-link :to="{ path: '/admin/roles/edit/'+props.row.uuid }">
                            <i class="fa fa-pencil"></i>
                        </router-link>
                    </template>

                </v-client-table>

            </b-card>
        </b-row>

    </div>
</template>

<script>

    import Vue from 'vue';
    import form from '@/helpers/form';
    import {ClientTable, Event} from 'vue-tables-2';
    import ExportActions from '@/components/ExportActions';
    import {getRoles} from '@/api/role-api';

    Vue.use(ClientTable);

    export default {
        name: 'list-roles',
        components: {
            ExportActions
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                    {
                        name: 'Nuevo Rol',
                        path: '/admin/roles/add',
                        brand: 'fa fa-user',
                        permissions: ['ROLE_NEW']
                    },
                ],
                columns: ['uuid', 'description'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        description: 'Rol'
                    },
                    columnsClasses: {
                        uuid: "fit"
                    },
                    sortable: ['description'],
                    filterable: ['description'],
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
                roles: [],
            }
        },
        mounted() {
            this.options.texts = form.tableLabels();
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getRoles();
        },
        methods: {
            async getRoles() {
                this.$_loadingMixin_showLoading();
                await getRoles()
                    .then((roles) => {
                      if (this.$store.getters.getTextFilter !== '' || this.$store.getters.getTextFilter !== null) {
                        let searchValue = this.$store.getters.getTextFilter;
                        document.querySelector('.VueTables__search__input').value  = this.$store.getters.getTextFilter;
                        let filteredRoles = roles.filter(function (e) {
                          return e.description === searchValue;
                        });
                        this.roles = filteredRoles;
                      }
                      if (this.$store.getters.getTextFilter === null || this.$store.getters.getTextFilter === ''){
                        this.roles = roles;
                      }
                    });
                this.$_loadingMixin_hideLoading();
            },
            getRolesFilteredData() {
                if (!!this.$refs.RolesTable) {
                    return this.$refs.RolesTable.allFilteredData.map(role => ({
                        'Descripción': role.description
                    }));
                } else {
                    return [];
                }
            },
            onFilter () {
                let _self = this;
                if (document.querySelector('.VueTables__search__input').value === '') {
                  _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
                  _self.getRoles();
                } else {
                  _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
                }
            }
        }
    }
</script>
